// extracted by mini-css-extract-plugin
export default {"card":"CompanyCard_card__8nYuH","header":"CompanyCard_header__HFu-a","headerRight":"CompanyCard_headerRight__-eb85","actions":"CompanyCard_actions__oqrTk"};